<template>
  <GeojsonLayer
    v-if="roomTextSource"
    :layer="layerStyle"
    :sourceId="sourceId"
    :source="roomTextSource"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'

export default {
  name: 'LayerRoomText',
  components: {
    GeojsonLayer
  },
  props: {
    layerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sourceId: 'source-room-text'
    }
  },
  computed: {
    ...mapGetters({
      isModelviewShowing: 'isModelviewShowing',
      isPlanviewShowing: 'isPlanviewShowing'
    }),
    ...mapState({
      roomsForSelectedLevel: (state) => state.roomsForSelectedLevel
    }),
    visibility() {
      return this.isPlanviewShowing || this.isModelviewShowing
    },
    layerStyle() {
      return {
        id: this.layerId,
        source: this.sourceId,
        type: 'symbol',
        layout: {
          visibility: this.visibility ? 'visible' : 'none',
          'text-field': ['format', ['get', 'displayName'], { 'font-scale': 1 }],
          'text-font': ['literal', ['Inter Medium', 'Arial Unicode MS Regular']],
          'text-size': 16
        },
        paint: {
          'text-opacity': 0.9,
          'text-color': '#ffffff',
          'text-halo-color': 'hsla(0, 0%, 0%, 0.5)',
          'text-halo-width': 1,
          'text-halo-blur': 0.5
        },
        minzoom: 17.5
      }
    },
    roomTextSource() {
      if (!this.roomsForSelectedLevel) return null
      const newSource = {
        type: 'geojson',
        data: {
          id: this.sourceId,
          type: 'FeatureCollection',
          features: []
        }
      }
      newSource.data = this.roomsForSelectedLevel.data
      return newSource
    }
  }
}
</script>
